import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { Badge } from '../components/common';

type Result = Awaited<ReturnType<typeof api.resolve>>;

export default function ResolvePage() {
  const [value, setValue] = useState('');
  const [by, setBy] = useState<'parent_company' | 'bucket' | 'alias'>('parent_company');
  const [result, setResult] = useState<Result | null>(null);
  const [busy, setBusy] = useState(false);

  async function run(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    try {
      setResult(await api.resolve(value, by));
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Resolve partner</h1>
          <p>
            Answers the question every Lambda asks at the top of a run: which parent is this? Use it
            to check that a Zoho value or bucket name routes where you expect before activating a
            parent.
          </p>
        </div>
      </div>

      <form className="card" onSubmit={run}>
        <div className="row">
          <label className="field">
            <span>Value</span>
            <input
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder="JW_Clarity, clarity-skybridge-datashare, Mediator Law Group…"
              required
            />
          </label>
          <label className="field" style={{ maxWidth: 220 }}>
            <span>Match by</span>
            <select value={by} onChange={(e) => setBy(e.target.value as typeof by)}>
              <option value="parent_company">Parent company / alias</option>
              <option value="bucket">S3 bucket</option>
            </select>
          </label>
          <div style={{ flex: '0 0 auto' }}>
            <button className="primary" disabled={busy}>
              Resolve
            </button>
          </div>
        </div>
      </form>

      {result && (
        <div className="card">
          <h2>Result</h2>
          {result.resolved ? (
            <>
              <div className="callout ok">
                <Badge tone="ok">resolved</Badge> <code>{result.input}</code> routes to{' '}
                <Link to={`/parents/${result.parent_key}`}>{result.display_name}</Link>
              </div>
              <pre className="json">{JSON.stringify(result, null, 2)}</pre>
            </>
          ) : (
            <div className="callout danger">
              <Badge tone="danger">no match</Badge> {result.explanation}
            </div>
          )}
        </div>
      )}
    </>
  );
}
